// Jours du planning : chaînes AAAA-MM-JJ (jour de Paris, donné par le serveur), jamais d'heure ni de fuseau du navigateur.
import type { Creneau } from './types.ts';

const midi = (j: string) => new Date(`${j}T12:00:00Z`);
const fmtLong = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
const fmtCourt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: '2-digit', month: '2-digit', timeZone: 'UTC' });
const fmtJourMois = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long', timeZone: 'UTC' });

/** « mardi 14 octobre » */
export const jourLong = (j: string) => fmtLong.format(midi(j));
/** « mar. 14/10 » */
export const jourCourt = (j: string) => fmtCourt.format(midi(j));
/** « 14 octobre » */
export const jourMois = (j: string) => fmtJourMois.format(midi(j));

export const ajouterJours = (j: string, n: number) => {
  const d = midi(j);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};
export const lundiDe = (j: string) => ajouterJours(j, -((midi(j).getUTCDay() + 6) % 7));
export const estWeekEnd = (j: string) => [0, 6].includes(midi(j).getUTCDay());

export const CRENEAUX: Record<Creneau, string> = { journee: 'Journée', matin: 'Matin', apres_midi: 'Après-midi' };

/** Lien « Itinéraire » (adresse du site) : ouvre l'application de cartes du téléphone, ou le site de cartes sur ordinateur. */
export function lienItineraire(adresse: string | null, ville: string | null) {
  const cible = [adresse, ville].filter((x) => x && x.trim()).join(', ');
  return cible ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(cible)}` : null;
}
